import { buildWorkspacesMapLayer } from "@lib/logic";
import { getWorkspaceOccupancyForBuildingAndFloorId, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { useFacilityMarkers } from "../../../organisms/hereAndNow/useFacilityMarkers";
import { HaNContext } from "../shell/HaNContext";
import { HaNMapStageContext, useHaNMapLayer } from "../shell/regions/HaNMapStageContext";

export const WorkspacesMap = () => {
  const { tab } = useRequiredContext(HaNContext);
  const { floorId } = useRequiredContext(HaNMapStageContext);

  if (tab !== "workspaces" || !floorId) return null;

  return <WorkspacesMapLayer floorId={floorId} />;
};

type WorkspacesMapLayerProps = {
  floorId: string;
};

// Builds the tab's layer for the page's one map, which the map stage draws
const WorkspacesMapLayer = ({ floorId }: WorkspacesMapLayerProps) => {
  const { building, filterData } = useRequiredContext(HaNContext);
  const buildingId = building.buildingId ?? "";

  const sensorData = useAppSelector(state => getWorkspaceOccupancyForBuildingAndFloorId(state, buildingId, floorId));
  const facilityMarkers = useFacilityMarkers(buildingId, floorId);

  const layer = buildWorkspacesMapLayer({
    floorId,
    areas: filterData.workspaces.filteredData,
    sensorData,
    facilityMarkers,
  });

  useHaNMapLayer(layer);

  return null;
};
